import supportedBrowsers from './supportedBrowsers';

export default () => {
  return supportedBrowsers.test(navigator.userAgent);
};
